var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStriptwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "28px",
    viewBox: "0 0 44 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31C0EFDA-8CFD-4CA8-ABFA-F0C9E44C988A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.701832, 4.666521)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 11.1535289,
    y: 1.99561266,
    width: 8.2673368,
    height: 14.6757333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6784916,9.33347932 C11.6758448,6.4696522 13.0066098,3.76372213 15.2872235,1.99561266 C11.413423,-1.01221052 5.85006753,-0.574433077 2.5071718,3.00126804 C-0.835723933,6.57696916 -0.835723933,12.0899895 2.5071718,15.6656906 C5.85006753,19.2413917 11.413423,19.6791692 15.2872235,16.671346 C13.0066255,14.903224 11.6758645,12.197302 11.6784916,9.33347932 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5739754,9.33347932 C30.5739754,12.90676 28.5088581,16.1664578 25.25532,17.7282041 C22.001782,19.2899504 18.131139,18.8795691 15.2872235,16.671346 C17.5657084,14.9015435 18.8959296,12.1966999 18.8959296,9.33347932 C18.8959296,6.4702588 17.5657084,3.7654151 15.2872235,1.99561266 C18.131139,-0.212610453 22.001782,-0.622991753 25.25532,0.938754554 C28.5088581,2.50050086 30.5739754,5.76019869 30.5739754,9.33347932 L30.5739754,9.33347932 Z",
    id: "Path",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.672547,15.1169571 L29.672547,14.8165015 L29.7951923,14.8165015 L29.7951923,14.7552904 L29.4828445,14.7552904 L29.4828445,14.8165015 L29.6055422,14.8165015 L29.6055422,15.1169571 L29.672547,15.1169571 Z M30.2789496,15.1169571 L30.2789496,14.7546941 L30.183206,14.7546941 L30.0730824,15.0038682 L29.9629274,14.7546941 L29.8671313,14.7546941 L29.8671313,15.1169571 L29.9347397,15.1169571 L29.9347397,14.8436978 L30.0380158,15.0792867 L30.1081176,15.0792867 L30.2113963,14.8431015 L30.2113963,15.1169571 L30.2789496,15.1169571 Z",
    id: "Shape",
    fill: "#F79E1B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStriptwo);
export default __webpack_public_path__ + "static/media/striptwo.167e9f7d5b9e6312e831a6b16d65313a.svg";
export { ForwardRef as ReactComponent };